import { _ } from "extensions/underscore";
import $ from "jquery";
import moment from "moment";
import { Backbone } from "extensions/backbone";

import { v2 } from "common/config/api";

import { pazienHistory } from "common/components/pazienHistory";

import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { WidgetTabsView, WidgetTabsModel } from "common/components/tabs/widgetTabs";

import { references } from "common/helpers/references";
import { CustomView } from "../customView";

import { TabBody } from "./tabBody";

const MAX_TABS = 4;
const MAX_SECONDARYPIVOT_ITEMS = 10;

export const ChargebackRateByNetworkView = CustomView.extend({
    type: "custom.chargebackRateByNetwork",
    className() {
        return `grid-stack-item widget3 custom ${this.type.replace(/\./g, "-")} chargebacks`;
    },
    
    events: {
        "click @ui.widgetTitle": "drilldown",
        "click .summary": function(event) {
            this.drilldown(null, {
                qualifiersStr: this.getPrimaryPivotQualifierFromEvent(event)
            });
        },
        ...CustomView.prototype.events
    },
    
    regions: {
        content: ".content"
    },
    
    attributes() {
        return {
            ...CustomView.prototype.attributes.apply(this, arguments),
            "gs-max-h": 10,
            "gs-min-w": 6,
            "gs-max-w": 12
        };
    },
    
    getAPIEndpoint: v2.chargebacks.rateByNetwork,
    
    getPrimaryPivotQualifierFromEvent(e) {
        const model = this.collection.at($(e.currentTarget).closest(".tab-pane").index());
        return `method:${model.get("payment_method")}`;
    },
    
    setDataCollection() {
        CustomView.prototype.setDataCollection.apply(this, arguments);
        
        this.collection.comparator = function(model) {
            return -1 * model.get("count");
        };
    },
    
    /**
     * Take a model and generate a layout tab based on its properties
     * @param {Backbone.Model} model
     * @private
     */
    _makeTab(model, index) {
        const paymentMethodAlias = references.toAlias(model.get("payment_method"), "payment_method");
        const items = (model.get("monthly_rates") || []).sort((a, b) => moment(b.month) - moment(a.month));
        const count = model.get("count");
        const itemsCollection = new Backbone.Collection(_.first(items, MAX_SECONDARYPIVOT_ITEMS) || []);
        
        // Since we artificially (from existing sources) create this collection, add `fetched` true
        itemsCollection.fetched = true;
        
        return {
            name: `${paymentMethodAlias}<span class='badge'>${count}</span>`,
            tooltip: `${paymentMethodAlias} (${count})`,
            active: index === 0,
            hideCloseIcon: true,
            view: TabBody,
            viewOptions: {
                collection: itemsCollection,
                model,
                widget: this
            }
        };
    },
    
    makeTabLayout() {
        this.tabLayout = new WidgetTabsView({
            model: new WidgetTabsModel({
                newTabButton: false,
                name: "pivots",
                tabs: (this.collection.first(MAX_TABS) || []).map(_.partial(this._makeTab, _, _), this)
            })
        });
        this.showChildView("content", this.tabLayout);
    },
    
    makeContent() {
        if (this.tabLayout) {
            this.makeTabLayout();
        } else if (!this.subscribedToFetch) {
            this.listenTo(this.collection, "fetched", this.makeTabLayout);
            this.subscribedToFetch = true;
        }
    },
    
    onDestroy() {
        CustomView.prototype.onDestroy.apply(this, arguments);
        this.tabLayout = null;
    },

    drilldown(e = false, ...rest) {
        if (e) {
            e.preventDefault();
        }
        this.drilldownToCorrespondingPage.apply(this, rest);
    },
    
    _doDrilldown({ qualifiersStr = "" } = {}) {
        const urlRoot = "analytics/chargebacks";

        const qualifiers = new Qualifiers({
            value: qualifiersStr
        });
        const display_options = new Qualifiers({
            value: "card:method"
        });

        // Build a new fragment now with search and display_options qualifiers
        const fragment = `${urlRoot}/${display_options.toString(true)}/${qualifiers.toString(true)}`;

        pazienHistory.navigateWithParams(fragment, {
            trigger: true
        });
    }
});
